export interface NativeCommonParams {
  orgCode: string;
  projectId: string;
  app_code: string;
  sellerId: string;
  userId?: string;
  authToken: string;
  isLogin?: boolean;
  salt: string;
  oppId?: string;
  sellerName?: string;
  sellerPhone?: string;
  projectName?: string;
  env: string;
  main_base_url?: string;
}

export interface CommonPageConfig {
  uiConfig: {
    colorTable: colorTableType;
  };
  commonParams: NativeCommonParams;
  pageConfig: any;
  extra: any;
}

interface colorTableType {
  [key: string]: string;
}

export enum Envs {
  DEV = 'DEV',
  TEST = 'TEST',
  RELEASE = 'RELEASE',
  PRO = 'PRO',
}
